// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3NHXq","footer":"ModalFilter_footer__yzG_X"};